import { shouldInitializeMemberCrypto, } from '@lucidlink/dto/web-service-api';
import { AES_ENCRYPTION_ALGO_PARAMS, arrayToAesKey, arrayToPrivateKey, base64ToArray, cryptoPairsFromArray, decryptWithAes, decryptWithRsaBlockCipher, encryptCryptoKeyWithAes, encryptWithAes, RSA_ENCRYPTION_ALGO_PARAMS, } from '@lucidlink/ts-crypto/crypto';
import { prepareMemberCommon } from '#sdk/common/member';
import { InvalidCryptoError } from '#sdk/workspace-client/crypto/workspace-crypto.error.ts';
import { prepareAcceptIndividualInvitationWithMemberCrypto } from './prepare-accept-invitation-with-member-crypto';
export const prepareAcceptIndividualInvitationDto = async (params) => {
    const invitationPrivateKeyArray = (await decryptWithAes(params.acceptableInvitationData.ePrivateKeyByInvitationSecret, await arrayToAesKey(params.linkSecret, AES_ENCRYPTION_ALGO_PARAMS))).buffer;
    if (shouldInitializeMemberCrypto({
        ...params.member,
        principalId: params.member.id,
    })) {
        return prepareAcceptIndividualInvitationWithMemberCrypto({
            ...params,
            invitationPrivateKeyArray,
        });
    }
    const invitationPrivateKey = await arrayToPrivateKey(invitationPrivateKeyArray, RSA_ENCRYPTION_ALGO_PARAMS);
    if (!params.member.ePrivateKeyByInvitationKey) {
        throw new InvalidCryptoError('Member crypto should be initialized!');
    }
    const memberPrivateKeyArray = await decryptWithRsaBlockCipher(params.member.ePrivateKeyByInvitationKey, invitationPrivateKey);
    const ePrivateKeyByUserKey = await encryptWithAes(memberPrivateKeyArray, params.userKey);
    return {
        invitationId: params.acceptableInvitationData.id,
        ePrivateKeyByUserKey,
    };
};
export const prepareAcceptOrganizationInvitationDto = async (params) => {
    const invitationPublicKeyArray = base64ToArray(params.acceptableInvitationData.publicKey);
    const invitationPrivateKeyArray = (await decryptWithAes(params.acceptableInvitationData.ePrivateKeyByInvitationSecret, await arrayToAesKey(params.linkSecret, AES_ENCRYPTION_ALGO_PARAMS))).buffer;
    const invitationKeys = await cryptoPairsFromArray(invitationPublicKeyArray, invitationPrivateKeyArray);
    const { member, memberKeys } = await prepareMemberCommon({
        workspaceId: params.acceptableInvitationData.workspace.id,
        invitationKeys,
    });
    const ePrivateKeyByUserKey = await encryptCryptoKeyWithAes(memberKeys.encryptPair.privateKey, params.userKey);
    return {
        ...member,
        invitationId: params.acceptableInvitationData.id,
        ePrivateKeyByUserKey,
    };
};
